
/* styles */
require("!!style-loader!css-loader!../../../../node_modules/_vue-loader@10.3.0@vue-loader/lib/style-rewriter?id=data-v-3d28665c&scoped=true!sass-loader!../../../../node_modules/_vue-loader@10.3.0@vue-loader/lib/selector?type=styles&index=0!./menu-item.vue")

var Component = require("!../../../../node_modules/_vue-loader@10.3.0@vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../../node_modules/_vue-loader@10.3.0@vue-loader/lib/selector?type=script&index=0!./menu-item.vue"),
  /* template */
  require("!!../../../../node_modules/_vue-loader@10.3.0@vue-loader/lib/template-compiler?id=data-v-3d28665c!../../../../node_modules/_vue-loader@10.3.0@vue-loader/lib/selector?type=template&index=0!./menu-item.vue"),
  /* scopeId */
  "data-v-3d28665c",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/tofu-menu/src/menu-item.vue
// module id = 589
// module chunks = 0